import React, { useEffect, useState } from "react";
import InfoTip from "../../../../utils/InfoTip";
import { JOB_STAGES } from "../../../../utils/candidatesV2Constants";
import { ASSIGNED_TO_TIP } from "../constants";
import CandidateRow from "./CandidateRow";

// Candidate-wise table. Owns which row's status menu / action menu is open (only one at a time).
const CandidatesTable = ({
  jobId, loading, candidateList, currentJobs, selectedJobs, onToggleSelect,
  allSelected, onSelectAll, selectableCount, isRestricted,
  access, showAssigneeColumn, onAssign, onQuickClear,
  hiringStatuses, statusLoading, onStatusPick, onAction,
  getCandidateStageScore, getDaysFromToday, disabled,
}) => {
  const [statusMenu, setStatusMenu] = useState({ id: null, pos: null });
  const [actionMenu, setActionMenu] = useState({ id: null, pos: null });
  const closeMenus = () => {
    setStatusMenu({ id: null, pos: null });
    setActionMenu({ id: null, pos: null });
  };

  useEffect(() => {
    const handler = (e) => {
      if (!e.target.closest(".status-dropdown-v2") && !e.target.closest(".status-dd-menu")) setStatusMenu({ id: null, pos: null });
      if (!e.target.closest(".action-more-wrap") && !e.target.closest(".action-more-menu")) setActionMenu({ id: null, pos: null });
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const colSpan = showAssigneeColumn ? 8 : 7;

  return (
    <div className="table-scroll-body" onScroll={closeMenus}>
      <table className="candidates-table-v2">
        <thead>
          <tr>
            <th className="th-check">
              <input
                type="checkbox"
                onChange={onSelectAll}
                checked={allSelected}
                disabled={selectableCount === 0}
                title={isRestricted ? "Selects only candidates assigned to you" : undefined}
              />
            </th>
            <th className="th-candidate">CANDIDATE</th>
            <th className="th-added">DAYS ADDED</th>
            <th className="th-resume">RESUME SCORE</th>
            <th className="th-stages">
              <div>Stage Scores</div>
              <div className="stage-abbrev-row">
                {JOB_STAGES.map((s, i) => (
                  <span key={s.name}>{s.abbrev}{i < JOB_STAGES.length - 1 && <span className="stage-dot"> · </span>}</span>
                ))}
              </div>
            </th>
            {showAssigneeColumn && (
              <th className="th-assignee">
                <span style={{ display: "inline-flex", alignItems: "center" }}>
                  ASSIGNED
                  <InfoTip text={ASSIGNED_TO_TIP} />
                </span>
              </th>
            )}
            <th className="th-status">STATUS</th>
            <th className="th-actions">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={colSpan}>
                <div className="table-loading">
                  <div className="spinner-border" role="status" style={{ color: "#F75891" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          ) : candidateList.length > 0 ? (
            currentJobs.map((job) => {
              const candidate = candidateList.find((c) => c.id === job.id);
              return (
                <CandidateRow
                  key={job.id}
                  jobId={jobId}
                  job={job}
                  candidate={candidate}
                  accessible={access.canAccessCandidate(candidate)}
                  assignee={access.getAssignee(candidate)}
                  selected={selectedJobs.includes(job.id)}
                  onToggleSelect={onToggleSelect}
                  showAssigneeColumn={showAssigneeColumn}
                  canManageAssignments={access.canManageAssignments}
                  onAssign={onAssign}
                  onQuickClear={onQuickClear}
                  hiringStatuses={hiringStatuses}
                  statusLoading={!!statusLoading[job.id]}
                  statusMenu={{
                    isOpen: statusMenu.id === job.id,
                    pos: statusMenu.pos,
                    open: (pos) => setStatusMenu({ id: job.id, pos }),
                    close: () => setStatusMenu({ id: null, pos: null }),
                  }}
                  onStatusPick={onStatusPick}
                  actionMenu={{
                    isOpen: actionMenu.id === job.id,
                    pos: actionMenu.pos,
                    open: (pos) => setActionMenu({ id: job.id, pos }),
                    close: () => setActionMenu({ id: null, pos: null }),
                  }}
                  onAction={onAction}
                  getCandidateStageScore={getCandidateStageScore}
                  getDaysFromToday={getDaysFromToday}
                  disabled={disabled}
                />
              );
            })
          ) : (
            <tr>
              <td colSpan={colSpan} className="no-data-cell">No candidates found</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CandidatesTable;
